module.exports = __webpack_public_path__ + "img/back.bc0e8a46.svg";